<template>
    
    <div>
        <el-form v-if="active==0" ref="projectsystemForm" style="text-align:left;width:500px;margin:0 auto;" :model="projectsystemForm" :rules="projectRules" class="project-form" auto-complete="on" label-width="120px">
    <!-- 项目名称 -->
            <el-form-item :label="$t('project.systemName')" prop="project_system_name">
                <el-input v-model="projectsystemForm.project_system_name" :placeholder="$t('project.unInputProjectSystem')" name="ProjectName" type="text" auto-complete="on" />
            </el-form-item>
	<!-- 系统类型 -->
	        <el-form-item :label="$t('project.systemType')" prop="sys_type_id">
	            <el-select v-model="projectsystemForm.sys_type_id" :placeholder="$t('project.unInputProjectType')" name="sysid" :disabled="isEdit">
	                <el-option
	                    v-for="v in systemType"
	                    :key="v.value"
	                    :disabled="v.disable"
	                    :label="v.label"
	                    :value="v.value">
	                </el-option>
	            </el-select>
	        </el-form-item>
    <!-- 备注 -->
            <el-form-item :label="$t('project.remark')">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="150" name="description" v-model="projectsystemForm.description"></el-input>
            </el-form-item>
        </el-form>
		<div v-if="projectsystemForm.sys_type_id==1">
		<template v-if="active==1">
			<label style="font-weight: bold;">添加主机（必填）</label>
			<ul>
		        <li v-for="(v, index) in mainframelist" :key="index" style="margin-bottom:10px;">
		            <el-row :gutter="20">
						<el-col :span="2">
							<el-input placeholder="序号" :value="v.id"></el-input>
						    <!-- <span >序号：{{v.id}}</span> -->
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.model" placeholder="型号"></el-input>
						</el-col>
		                <el-col :span="2">
		                    <el-input v-model="v.brand" placeholder="品牌"></el-input>
		                </el-col>
						<el-col :span="2">
						    <el-input v-model="v.refrigerating_capacity" placeholder="制冷量"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.power" placeholder="功率"></el-input>
						</el-col>
						<el-col :span="3">
						    <el-input v-model="v.energy_efficiency_ratio" placeholder="能效比"></el-input>
						</el-col>
						<el-col :span="3">
						    <el-input v-model="v.production_time" placeholder="出厂时间:xxxx-xx-xx"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.count" placeholder="数量"></el-input>
						</el-col>
						<el-col :span="2">
                                <el-select style="width:100%" v-model="v.status" filterable placeholder="状态">
                                    <el-option
                                        v-for="item in statuslist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
						</el-col>
						<el-col :span="1">
						    <el-button type="danger" size="mini" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
						</el-col>
		            </el-row>
		        </li>
		    </ul>
		</template>
		<!-- 水泵 -->
		<template v-if="active==2">
			<label style="font-weight: bold;">添加水泵（必填）</label>
			<ul>
		        <li v-for="(v, index) in waterpumplist" :key="index" style="margin-bottom:10px;">
		            <el-row :gutter="20">
						<el-col :span="2">
						        <el-select style="width:100%" v-model="v.watertype" filterable placeholder="水泵类型">
						            <el-option
						                v-for="item in waterlist"
						                :key="item.value"
						                :label="item.label"
						                :value="item.value">
						            </el-option>
						        </el-select>
						</el-col>
						<el-col :span="2">
							<el-input placeholder="序号" :value="v.id"></el-input>
						    <!-- <span >序号：{{v.id}}</span> -->
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.model" placeholder="型号"></el-input>
						</el-col>
		                <el-col :span="2">
		                    <el-input v-model="v.brand" placeholder="品牌"></el-input>
		                </el-col>
						<el-col :span="2">
						        <el-select style="width:100%" v-model="v.frequency_type" filterable placeholder="定/变频">
						            <el-option
						                v-for="item in frequencylist"
						                :key="item.value"
						                :label="item.label"
						                :value="item.value">
						            </el-option>
						        </el-select>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.power" placeholder="功率"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.flow" placeholder="流量"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.lift" placeholder="扬程"></el-input>
						</el-col>
						<el-col :span="3">
						    <el-input v-model="v.production_time" placeholder="出厂时间:xxxx-xx-xx"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.count" placeholder="数量"></el-input>
						</el-col>
						<el-col :span="2">
                                <el-select style="width:100%" v-model="v.status" filterable placeholder="状态">
                                    <el-option
                                        v-for="item in statuslist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
						</el-col>
						<el-col :span="1">
						    <el-button type="danger" size="mini" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
						</el-col>
		            </el-row>
		        </li>
		    </ul>
		</template>
		<!-- 水塔 -->
		<template v-if="active==3">
			<label style="font-weight: bold;">添加水塔（必填）</label>
			<ul>
		        <li v-for="(v, index) in watertowerlist" :key="index" style="margin-bottom:10px;">
		            <el-row :gutter="20">
						<el-col :span="2">
							<el-input placeholder="序号" :value="v.id"></el-input>
						    <!-- <span >序号：{{v.id}}</span> -->
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.model" placeholder="型号"></el-input>
						</el-col>
		                <el-col :span="2">
		                    <el-input v-model="v.brand" placeholder="品牌"></el-input>
		                </el-col>
						<el-col :span="2">
						        <el-select style="width:100%" v-model="v.frequency_type" filterable placeholder="定/变频">
						            <el-option
						                v-for="item in frequencylist"
						                :key="item.value"
						                :label="item.label"
						                :value="item.value">
						            </el-option>
						        </el-select>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.power" placeholder="功率"></el-input>
						</el-col>
						<el-col :span="3">
						    <el-input v-model="v.production_time" placeholder="出厂时间:xxxx-xx-xx"></el-input>
						</el-col>
						<el-col :span="2">
						    <el-input v-model="v.count" placeholder="数量"></el-input>
						</el-col>
						<el-col :span="2">
                                <el-select style="width:100%" v-model="v.status" filterable placeholder="状态">
                                    <el-option
                                        v-for="item in statuslist"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
						</el-col>
						<el-col :span="1">
						    <el-button type="danger" size="mini" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
						</el-col>
		            </el-row>
		        </li>
		    </ul>
		</template>
		</div>
		<div v-if="false">
			<template v-if="active==1">
				<label style="font-weight: bold;">添加风机盘管（必填）</label>
				<ul>
			        <li v-for="(v, index) in fanlist" :key="index" style="margin-bottom:10px;">
			            <el-row :gutter="20">
							<el-col :span="2">
								<el-input placeholder="序号" :value="v.id"></el-input>
							    <!-- <span >序号：{{v.id}}</span> -->
							</el-col>
							<el-col :span="2">
							    <el-input v-model="v.model" placeholder="型号"></el-input>
							</el-col>
			                <el-col :span="2">
			                    <el-input v-model="v.brand" placeholder="品牌"></el-input>
			                </el-col>
							<el-col :span="2">
							    <el-input v-model="v.power" placeholder="功率"></el-input>
							</el-col>
							<el-col :span="3">
							    <el-input v-model="v.production_time" placeholder="出厂时间:xxxx-xx-xx"></el-input>
							</el-col>
							<el-col :span="2">
							    <el-input v-model="v.count" placeholder="数量"></el-input>
							</el-col>
							<el-col :span="2">
			                        <el-select style="width:100%" v-model="v.status" filterable placeholder="状态">
			                            <el-option
			                                v-for="item in statuslist"
			                                :key="item.value"
			                                :label="item.label"
			                                :value="item.value">
			                            </el-option>
			                        </el-select>
							</el-col>
							<el-col :span="1">
							    <el-button type="danger" size="mini" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
							</el-col>
			            </el-row>
			        </li>
			    </ul>
			</template>
			<template v-if="active==2">
				<label style="font-weight: bold;">添加风柜（必填）</label>
				<ul>
			        <li v-for="(v, index) in airlist" :key="index" style="margin-bottom:10px;">
			            <el-row :gutter="20">
							<el-col :span="2">
								<el-input placeholder="序号" :value="v.id"></el-input>
							    <!-- <span >序号：{{v.id}}</span> -->
							</el-col>
							<el-col :span="2">
							    <el-input v-model="v.model" placeholder="型号"></el-input>
							</el-col>
			                <el-col :span="2">
			                    <el-input v-model="v.brand" placeholder="品牌"></el-input>
			                </el-col>
							<el-col :span="2">
							    <el-input v-model="v.power" placeholder="功率"></el-input>
							</el-col>
							<el-col :span="3">
							    <el-input v-model="v.production_time" placeholder="出厂时间:xxxx-xx-xx"></el-input>
							</el-col>
							<el-col :span="2">
							    <el-input v-model="v.count" placeholder="数量"></el-input>
							</el-col>
							<el-col :span="2">
			                        <el-select style="width:100%" v-model="v.status" filterable placeholder="状态">
			                            <el-option
			                                v-for="item in statuslist"
			                                :key="item.value"
			                                :label="item.label"
			                                :value="item.value">
			                            </el-option>
			                        </el-select>
							</el-col>
							<el-col :span="1">
							    <el-button type="danger" size="mini" icon="el-icon-delete" @click="hanldeDelete(v, index)"></el-button>
							</el-col>
			            </el-row>
			        </li>
			    </ul>
			</template>
		</div>
		<el-button v-if="active!=0" size="small" @click="handleAddRow">增加一行</el-button>
		<div class="btn-container" style="text-align: center;">
			<el-button v-if="active!=0" class="btn" v-loading="loading" type="primary" @click.native.prevent="pre">上一步</el-button>
			<el-button v-if="shownext && projectsystemForm.sys_type_id==1" class="btn" v-loading="loading" type="primary" @click.native.prevent="next">下一步</el-button>
		    <el-button v-if="projectsystemForm.sys_type_id!=1 || !shownext" class="btn" v-loading="loading" type="primary" @click.native.prevent="submitProject">{{ $t('btns.sure') }}</el-button>
		</div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from '@/config'
import Storage from '@/utils/storage'
import Service from '@/api/Service'
import { SYSTEMTYPE } from '@/api/configData'
// import stringUtils from '@/utils/stringUtils'
export default {
    name: "systemform",
    props: ["editData"],
    inject: ['handleEdit'],
    data() {
        return {
			statuslist:[
				{
					value:"using",
					label:"使用中"
				},
				{
					value:"replaced",
					label:"已替换"
				}
			],
			waterlist:[
				{
					value:1,
					label:"冷却泵"
				},
				{
					value:2,
					label:"冷冻泵"
				}
			],
			frequencylist:[
				{
					value:'fixed_frequency',
					label:"定频"
				},
				{
					value:'"variable_frequency",',
					label:"变频"
				}
			],
            // 系统表单信息
            projectsystemForm: {
                project_id: "", //所属项目id
                sys_type_id:'', //系统id
				project_system_name: '',     //系统名称
				description: "",     //  备注
				oid:'',//项目子系统id
				terminal_info:''
				
            },
			//表单验证
			projectRules: {
			// 系统名称
			project_system_name: [{ required: true, trigger: "blur", message: this.$t("project.unInputProjectSystem") }],
			//系统id
			sys_type_id: [{ required: true, trigger: "change", message: this.$t("project.unInputProjectType") }],
			},
			systemType: SYSTEMTYPE,
			loading: false,
			active:0,
			mainframelist:[],
			waterpumplist:[],
			watertowerlist:[],
			fanlist:[],
			airlist:[],
			shownext:true,
        };
    },
    components: {
        // CmpSchemeDetail
    },
    created() {
        this.initProjectData();
        // 获取系统模型列表
        this.$store.dispatch("getTemplateList");
        // 获取方案列表
        // this.$store.dispatch("getChargeScheme");
		this.getProjectid()
        // this.getProvince();
    },
    watch: {
        editData(newData) {
            if (newData) {
                this.initProjectData();
            }
        }
    },
    computed: {
        // 是否是创建系统
        isEdit() {
            return JSON.stringify(this.editData) != '{}'
        },
        ...mapGetters(["baseData"]),
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        }
    },
    methods: {
		//下一页
		next(){
			if(this.active==0){
				this.$refs.projectsystemForm.validate(valid => {
					if (valid) {
						this.active=this.active +1
					}
				});
				
			}else if(this.active==1){
				if(this.mainframelist.length>0 || this.fanlist.length>0){
					this.active +=1
				}
				if(this.projectsystemForm.sys_type_id!=1){
					this.shownext=false
				}
			}else if(this.active==2){
				if(this.waterpumplist.length>0){
					this.active +=1
					this.shownext=false
				}
			}
			
		},
		pre(){
			this.active=this.active - 1
			this.shownext=true
		},
		hanldeDelete(v, index) {
			if(this.projectsystemForm.sys_type_id==1){
				if(this.active === 1) {
					this.mainframelist.splice(index, 1); 
					return
					}else if(this.active === 2){
						this.waterpumplist.splice(index, 1); 
						return
					}else if(this.active === 3){
						this.watertowerlist.splice(index, 1); 
						return
					}
				}
		},
		handleAddRow() {
		if(this.projectsystemForm.sys_type_id==1){
		if(this.active === 1) {
			this.mainframelist.push(
				{
					id:this.mainframelist.length+1,
					model: "",
					brand: "",
					refrigerating_capacity:'',
					power:"" ,
					energy_efficiency_ratio: '',
					production_time: "",
					count:'' ,
					status: ""
				},
			);
			return
			}else if(this.active === 2){
				this.waterpumplist.push(
					{
						watertype:'',
						id:this.waterpumplist.length+1,
						model: "",
						brand: "",
						frequency_type:'',
						power:"" ,
						flow:'',
						lift: '',
						production_time: "",
						count:'' ,
						status: ''
					},
				);
			}else if(this.active === 3){
				this.watertowerlist.push(
					{
						watertype:'',
						id:this.watertowerlist.length+1,
						model: "",
						brand: "",
						frequency_type:'',
						power:"" ,
						production_time: "",
						count:'' ,
						status: ''
					},
				);
			}
			}else{
				if(this.active === 1) {
					this.fanlist.push(
						{
							id:this.fanlist.length+1,
							model: "",
							brand: "",
							refrigerating_capacity:'',
							power:"" ,
							energy_efficiency_ratio: '',
							production_time: "",
							count:'' ,
							status: ""
						},
					);
					return
					}else if(this.active === 2){
						this.airlist.push(
							{
								watertype:'',
								id:this.airlist.length+1,
								model: "",
								brand: "",
								frequency_type:'',
								power:"" ,
								flow:'',
								lift: '',
								production_time: "",
								count:'' ,
								status: ''
							},
						);
					}
				
			}
		},
		//获取子系统所属项目id
		async getProjectid(){
			let data = await Service.getProjectId()
			this.projectsystemForm.project_id = data
		},
        // 初始化数据
        initProjectData() {
            if (JSON.stringify(this.editData) != '{}') {
                this.projectsystemForm = Object.assign(
                    {},
                    this.projectsystemForm,
                    this.editData
                );
				this.projectsystemForm.oid=this.editData.oid
            }
        },
        // 确认提交
        submitProject() {
			if(this.active===3 && this.watertowerlist.length==0){
				return
			}
			if(this.active===2 && this.airlist.length==0){
				return
			}
			var list={}
			if(this.projectsystemForm.sys_type_id==1){
				list.mainframe=this.mainframelist
				list.water_pump=this.waterpumplist
				list.water_tower=this.watertowerlist	
			}else{
				list.fan_coll=this.fanlist
				list.air_handler=this.airlist
			}
			
			this.projectsystemForm.terminal_info=list
                    if(JSON.stringify(this.editData) != '{}'){
                        // 编辑项目子系统
                        this.editProject();
                    }else{
                        // 新建项目子系统
                        this.addSystem();
                    }			
            // this.$refs.projectsystemForm.validate(valid => {
            //     if (valid) {
            //         if(JSON.stringify(this.editData) != '{}'){
            //             // 编辑项目子系统
            //             this.editProject();
            //         }else{
            //             // 新建项目子系统
            //             this.addSystem();
            //         }
            //     }
            // });
        },
		//修改系统信息
        async editProject() {
            let data = await Service.editProjectSystem(this.projectsystemForm);
            if(data){
                this.$message({
                    message: '更新成功',
                    type: 'success',
                    duration: 2000,
                    onClose: () => {
                        this.handleEdit();
                    }
                });
            }
        },
        async addSystem() {
            let data = await Service.addProjectSystem(this.projectsystemForm);
            if(data){
                this.$message({
                    message: '新增成功',
                    type: 'success',
                    duration: 2000,
                    onClose: () => {
                        this.$router.push('/projectsystemlist')
                    }
                });
            }
        },
    }
};
</script>
<style lang="less">
.upload-progress{
    position: absolute;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
}
.avatar-uploader .el-upload{
    position: relative;
    line-height: 0;
}
.avatar-uploader .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: @primary-color;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
.project-form .btn {
    margin: 24px 80px 0 80px;
    width: calc(100% - 80px);
}
.project-form-edit .project-form .btn{
    width: calc(100% - 150px);
}

.regions-select{
    width: 120px;
    &:nth-child(2){
        margin: 0 10px;
    }
}
</style>
